// TODO: consolidate under ../constants?

export enum TextColor {
  Salmon = 'foreground-salmon',
  CornflowerBlue = 'foreground-dark-blue',
  CarolinaBlue = 'foreground-light-blue',
  Tangerine = 'foreground-tangerine',
}
